export default __webpack_public_path__ + "static/media/you-can-do-it-1920w.826044e8.png";